import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getSortState } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC, SORT } from 'app/shared/util/pagination.constants';
import { getEntities } from './user-custom.reducer';

export const UserCustom = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const userCustomList = useAppSelector(state => state.userCustom.entities);
  const loading = useAppSelector(state => state.userCustom.loading);
  const totalItems = useAppSelector(state => state.userCustom.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <h2 id="user-custom-heading" data-cy="UserCustomHeading">
        <Translate contentKey="fleetSenseApp.userCustom.home.title">User Customs</Translate>
        <div className="d-flex justify-content-end">
          <Button className="mr-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} /> <Translate contentKey="fleetSenseApp.userCustom.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="fleetSenseApp.userCustom.home.createLabel">Create new User Custom</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {userCustomList && userCustomList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <DoNotShowInProduction>
                  <th className="hand" onClick={sort('id')}>
                    <Translate contentKey="fleetSenseApp.userCustom.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                  </th>
                </DoNotShowInProduction>
                <th className="hand" onClick={sort('phone')}>
                  <Translate contentKey="fleetSenseApp.userCustom.phone">Phone</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('activated')}>
                  <Translate contentKey="fleetSenseApp.userCustom.activated">Activated</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('registry')}>
                  <Translate contentKey="fleetSenseApp.userCustom.registry">Registry</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('identificationCode')}>
                  <Translate contentKey="fleetSenseApp.userCustom.identificationCode">Identification Code</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('licenseValidity')}>
                  <Translate contentKey="fleetSenseApp.userCustom.licenseValidity">License Validity</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.userCustom.user">User</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <DoNotShowInProduction>
                  <th>
                    <Translate contentKey="fleetSenseApp.userCustom.company">Company</Translate> <FontAwesomeIcon icon="sort" />
                  </th>
                </DoNotShowInProduction>
                <th />
              </tr>
            </thead>
            <tbody>
              {userCustomList.map((userCustom, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <DoNotShowInProduction>
                    <td>
                      <Button tag={Link} to={`${match.url}/${userCustom.id}`} color="link" size="sm">
                        {userCustom.id}
                      </Button>
                    </td>
                  </DoNotShowInProduction>
                  <td>{userCustom.phone}</td>
                  <td>{userCustom.activated ? 'true' : 'false'}</td>
                  <td>{userCustom.registry}</td>
                  <td>{userCustom.identificationCode}</td>
                  <td>{userCustom.licenseValidity ? <TextFormat type="date" value={userCustom.licenseValidity} format={APP_LOCAL_DATE_FORMAT} /> : null}</td>
                  <td>{userCustom.user ? userCustom.user.login : ''}</td>
                  <DoNotShowInProduction>
                    <td>{userCustom.company ? <Link to={`company/${userCustom.company.id}`}>{userCustom.company.name}</Link> : ''}</td>
                  </DoNotShowInProduction>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${userCustom.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${userCustom.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${userCustom.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.userCustom.home.notFound">No User Customs found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={userCustomList && userCustomList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default UserCustom;
